export default function () {
    const $body = $('body');
    const $searchboxInput = $('.searchbox__control');

    // toggle navigation mobile / tablet
    function toggleNavigation(navigationLevel, nextLevel) {
        if (window.innerWidth < 1024) {
            $(`.${navigationLevel}__link`).on('click', (e) => {
                const $currentNavLink = $(e.target);
                const $currentNavItem = $currentNavLink.closest(`.${navigationLevel}__item`);

                if ($currentNavItem.hasClass(`${navigationLevel}--subpages`)) {
                    e.preventDefault();
                    $currentNavItem.toggleClass('active');
                    $currentNavLink.toggleClass('active');
                    $currentNavItem.find(`.${nextLevel}`).slideToggle();
                }
            });
        }
    }

    // show third level on desktop
    function showThirdLevelNavigation() {
        $body.on('mouseover touchstart', '.second-level__link', (e) => {
            if (window.innerWidth > 1023) {
                const $currentNavLink = $(e.target);
                const $currentNavItem = $currentNavLink.closest('.second-level__item ');
                const $thirdNavList = $currentNavItem.find('.third-level');
                const $thirdNavColumn = $('.mega-menu__column.second');
                let content = '';

                $thirdNavColumn.hide();
                $('.second-level__link').removeClass('hover');
                if ($thirdNavList.length > 0) {
                    const $thirdLevelClone = $thirdNavList.clone().addClass('active');
                    $currentNavLink.addClass('hover');
                    content = $thirdLevelClone[0].outerHTML;
                    $thirdNavColumn.show();
                }
                $thirdNavColumn.html(content);
            }
        });

        $body.on('mouseover touchstart', '.first-level__link', (e) => {
            if (window.innerWidth > 1023) {
                const $currentNavLink = $(e.target);
                const $currentNavItem = $currentNavLink.closest('.first-level__item');
                const $firstSecondlevelItem = $currentNavItem.find('.second-level--subpages').first();
                const $firstSecondlevelLink = $firstSecondlevelItem.find('.second-level__link');
                const $thirdNavList = $firstSecondlevelItem.find('.third-level');
                const $thirdNavColumn = $('.mega-menu__column.second');
                let content = '';

                $thirdNavColumn.hide();
                $('.second-level__link').removeClass('hover');
                if ($thirdNavList.length > 0) {
                    const $thirdLevelClone = $thirdNavList.clone().addClass('active');
                    $firstSecondlevelLink.addClass('hover');
                    content = $thirdLevelClone[0].outerHTML;
                    $thirdNavColumn.show();
                }
                $thirdNavColumn.html(content);
            }
        });
    }

    $body.on('click', (e) => {
        // hide searchbox on click everywhere else but searchbox
        const $searchBox = $('.searchbox');
        if ($(e.target).closest('.searchbox').length === 0) {
            $searchBox.removeClass('active');
            $searchBox.find('.searchbox__control').removeClass('active');
        }

        // hide navigation mobile
        if (window.innerWidth < 1024) {
            if ($(e.target).closest('.header').length === 0) {
                $('.navbar-toggle').removeClass('open');
                $('.header-bottom').removeClass('active');
                $body.removeClass('dim-it');
            }
        }
    });

    $('.searchbox__icon').on('click', (e) => {
        const $searchBox = $(e.currentTarget).closest('.searchbox');
        $searchBox.find('.searchbox__control').toggleClass('active');
        $searchBox.toggleClass('active');
    });

    // seachbox background on focus
    $searchboxInput.on('focus', (e) => {
        const $element = $(e.target);
        const $searchbox = $element.closest('.searchbox');
        $searchbox.addClass('focused');
    });

    $searchboxInput.on('blur', (e) => {
        const $element = $(e.target);
        const $searchbox = $element.closest('.searchbox');
        $searchbox.removeClass('focused');
    });

    // toggle navigation
    $('.navbar-toggle').on('click', (e) => {
        $(e.currentTarget).toggleClass('open');
        $('.header-bottom').toggleClass('active');
        $body.toggleClass('dim-it');
    });

    // show third level on desktop
    function darkenBackground() {
        $body.on('mouseover', '.first-level__item', () => {
            if (window.innerWidth > 1023) {
                $body.addClass('dim-it');
            }
        });

        $body.on('mouseout', '.first-level__item', () => {
            if (window.innerWidth > 1023) {
                $body.removeClass('dim-it');
            }
        });
    }

    // hide navigation on scroll down and show on scroll up again
    let lastScroll = 0;
    let pageNavItemClicked = false;
    let scrolling = false;
    let scrollNumber;

    $(window).scroll(() => {
        scrolling = true;
    });

    setInterval(function intervalHandler() {
        if (scrolling) {
            scrolling = false;

            // current scroll position
            const scrollTop = $(this).scrollTop();

            // detect amount of scrolling
            scrollNumber = lastScroll - scrollTop;

            if (scrollTop > 135) {
                // Determines up-or-down scrolling
                if (scrollTop > lastScroll) {
                    // scroll down
                    $('.header').addClass('not-sticky').removeClass('sticky');
                    $('.sidebar-sticky').removeClass('top-header');
                } else if (scrollNumber >= 300 && !pageNavItemClicked) {
                    // scroll up
                    // show header only when scrolled more then 300 px
                    // and onpage nav item isnt clicked
                    $('.header').removeClass('not-sticky').addClass('sticky');
                    $('.sidebar-sticky').addClass('top-header');
                }
            } else {
                $('.header').removeClass('sticky');
                $('.sidebar-sticky').removeClass('top-header');
            }
            lastScroll = scrollTop;
        }
    }, 200);

    // detect click on onpage navigation item
    $(window).on('onpagenav-item-clicked', () => {
        pageNavItemClicked = true;
    });

    // detect end of scroll event
    $(window).on('scroll-end', () => {
        pageNavItemClicked = false;
    });

    darkenBackground(); // only desktop
    showThirdLevelNavigation(); // only desktop
    toggleNavigation('first-level', 'second-level'); // toggle navigation for first level on mobile
    toggleNavigation('second-level', 'third-level'); // toggle navigation for second level on mobile
}
